import PropTypes from "prop-types";
import { filterListByKeywordGivenKeyNames } from "../../utils/helpers/objects";
import Card from "../Card";
import NoResultsFound from "../NoResultsFound";
import Table from "../Table";
import Tabs from "../Tabs/index";
import TabPanel from "../Tabs/TabPanel/index";
import Toggle, { toggleSides } from "../Toggle";

import "./CardWithTable.scss";

const CardWithTable = ({
  id,
  isLoading,
  pluralTitle,
  singularTitle,
  columns,
  tableData,
  ownerCount,
  searchKeyword,
  onClickToggle,
  toggleSelectedOption,
  ownerType,
  filters,
  counterToggle
}) => {
  if (tableData.length === 0 && searchKeyword) {
    return <NoResultsFound searchKeyword={searchKeyword} />;
  }

  if (isLoading) {
    return (
      <Card
        id={id}
        collapsible={false}
        openByDefault
        className="card-with-table"
      >
        Loading...
      </Card>
    );
  }

  const toggleLeftText = `All ${pluralTitle} (${ownerCount.all})`;
  const toggleRightText = `My ${pluralTitle} (${ownerCount.my})`;
  const tableTitle =
    toggleSelectedOption === "left" ? toggleLeftText : toggleRightText;

  const tableProps = {
    tableTypePlural: pluralTitle,
    tableTypeSingular: singularTitle,
    columns,
    isAll: toggleSelectedOption === "left",
  };

  return (
    <Card id={id} collapsible={false} openByDefault className="card-with-table">
      {counterToggle ?
        <Table
            {...tableProps}
            title={`${tableTitle} - All sectors`}
            totalCount={ownerCount.all}
            lists={tableData}
          />
        :
          <>
            <div className="card__toggle-container">
              <Toggle
                leftText={toggleLeftText}
                rightText={toggleRightText}
                onClick={onClickToggle}
                selectedOption={toggleSelectedOption}
              />
            </div>

            <Tabs>
              <TabPanel title="All" totalCount={tableData?.length}>
              <Table
              {...tableProps}
              title={`${tableTitle} - All sectors`}
              totalCount={ownerCount.all}
              lists={tableData}
            />
          </TabPanel>

          {filters.map(({ key, raw, count }) => (
            <TabPanel key={key} title={raw} totalCount={count}>
              <Table
                {...tableProps}
                title={`${tableTitle} - ${raw} sector`}
                totalCount={count}
                lists={filterListByKeywordGivenKeyNames(tableData, raw, "sector")}
              />
            </TabPanel>
          ))} 
        </Tabs>
      </>
      }
    </Card>
  );
};

const ownerTypes = ["all", "my"];

CardWithTable.propTypes = {
  id: PropTypes.string.isRequired,
  pluralTitle: PropTypes.string,
  singularTitle: PropTypes.string,
  columns: PropTypes.array,
  tableData: PropTypes.array,
  ownerCount: PropTypes.shape({
    all: PropTypes.number,
    my: PropTypes.number,
  }),
  searchKeyword: PropTypes.string,
  onClickToggle: PropTypes.func,
  toggleSelectedOption: PropTypes.oneOf(toggleSides),
  ownerType: PropTypes.oneOf(ownerTypes),
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      all: PropTypes.number,
      my: PropTypes.number,
    })
  ),
};

CardWithTable.defaultProps = {
  id: "card-with-table",
  pluralTitle: "",
  singularTitle: "",
  tableData: [],
  columns: [],
  ownerCount: { all: 0, my: 0 },
  searchKeyword: "",
  onClickToggle: undefined,
  toggleSelectedOption: "left",
  ownerType: "all",
  filters: [],
  counterToggle: false
};

export default CardWithTable;
